import api from "./api.js";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback;

class ProfileService {
  async uploadProfileImage(imageFile) {
    try {
      const formData = new FormData();
      formData.append("profileImage", imageFile);

      const response = await api.post("/profile/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to upload profile image")
      );
    }
  }

  async deleteProfileImage() {
    try {
      const response = await api.delete("/profile/delete");
      return response.data;
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to delete profile image")
      );
    }
  }

  async getProfileImageInfo() {
    try {
      const response = await api.get("/profile/info");
      return response.data;
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to get profile image info")
      );
    }
  }

  async updateProfile(profileData) {
    try {
      const response = await api.put("/users/profile", profileData);
      return response.data;
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to update profile")
      );
    }
  }
}

const profileService = new ProfileService();

export default profileService;

